export const filters = {

  servicesTypesOptions : [
    { text: 'Apotheker', value: 'substitution' },
    { text: 'PTA', value: 'pta' },
    { text: 'PKA', value: 'pka' },
  ],

  committedStatesOptions : [
    { text: 'zugesagte', value: 'true' },
    { text: 'nicht-zugesagte', value: 'false' },
  ],

  distanceOptions : [
    { text: '5 km', value: '5' },
    { text: '10 km', value: '10' },
    { text: '50 km', value: '50' },
    { text: '100 km', value: '100' },
    { text: '200 km', value: '200' },
  ],

  sortOptions : [
    {
      text: 'Datum des Termins',
      value: 'date',
    },
    {
      text: 'Erstellungsdatum',
      value: 'created',
    },
    {
      text: 'Anzahl der Termine',
      value: 'group_size',
    },
  ],
  wwsOptions : [
    {
      text: 'ADG',
      value: 'ADG',
    },
    {
      text: 'ADV Oberhausen',
      value: 'ADV Oberhausen',
    },
    {
      text: 'Aposoft',
      value: 'Aposoft',
    },
    {
      text: 'Apotechnik',
      value: 'Apotechnik',
    },
    {
      text: 'Asys',
      value: 'Asys',
    },
    {
      text: 'Cida',
      value: 'Cida',
    },
    {
      text: 'Deos',
      value: 'Deos',
    },
    {
      text: 'Gawis',
      value: 'Gawis',
    },
    {
      text: 'Hagedorn',
      value: 'Hagedorn',
    },
    {
      text: 'Infopharm',
      value: 'Infopharm',
    },
    {
      text: 'Jump',
      value: 'Jump',
    },
    {
      text: 'Lauer Fischer',
      value: 'Lauer Fischer',
    },
    {
      text: 'ONE',
      value: 'ONE',
    },
    {
      text: 'Pharmasoft',
      value: 'Pharmasoft',
    },
    {
      text: 'Pharmatechnik',
      value: 'Pharmatechnik',
    },
    {
      text: 'Prokas',
      value: 'Prokas',
    },
    {
      text: 'Promedisoft',
      value: 'Promedisoft',
    },
  ],

  isVisibleOptions : [
    {
      text: 'sichtbar',
      value: 'false',
    },
    {
      text: 'nicht-sichtbar',
      value: 'true',
    },
  ],

  isProposedOptions : [
    {
      text: 'wurde vorgeschlagen',
      value: 'true',
    },
    {
      text: 'nicht vorgeschlagen',
      value: 'false',
    },
  ],

  isDirectPharmacyOptions : [
    {
      text: 'direkt Apotheke',
      value: 'true',
    },
    {
      text: 'keine direkt Apotheke',
      value: 'false',
    },
  ],

  isNightShiftOptions : [
    {
      text: 'Nachtschicht',
      value: 'true',
    },
    {
      text: 'keine Nachtschicht',
      value: 'false',
    },
  ],

  isHBAOptions : [
    {
      text: 'HBA',
      value: 'true',
    },
    {
      text: 'kein HBA',
      value: 'false',
    },
  ],

  isRequestedOptions : [
    {
      text: 'angefragt',
      value: 'true',
    },
    {
      text: 'nicht-angefragt',
      value: 'false',
    },
  ],

  isSelfAssignableOptions : [
    {
      text: 'Selbstzuweisung an',
      value: 'true',
    },
    {
      text: 'Selbstzuweisung aus',
      value: 'false',
    },
  ],

  directProposalOptions : [
    {
      text: 'Direkter Vorschlag an',
      value: 'true',
    },
    {
      text: 'Direkter Vorschlag aus',
      value: 'false',
    },
  ],

  userStateOptions : [
    {
      text: 'Automatisch freigegeben',
      value: 'auto_approved',
    },
    {
      text: 'Bestätigt',
      value: 'approved',
    },
    {
      text: 'Warte auf Korrektur',
      value: 'awaiting',
    },
    {
      text: 'Unbestätigt',
      value: '',
    },
  ],

  appointmentWfStatesOptions: [
    {
        text: 'Entwurf',
        value: 'initial',
    },
    {
        text: 'Angefragt',
        value: 'inquired',
    },
    {
        text: 'in Bearbeitung',
        value: 'open',
    },
    {
        text: 'Vergeben',
        value: 'allocated',
    },
    {
        text: 'Apobilanz',
        value: 'apobilanz',
    },
    {
        text: 'in vorl. Rechnung',
        value: 'tempInvoice',
    },
    {
        text: 'in Rechnung',
        value: 'invoice',
    },
    {
        text: 'Bezahlt',
        value: 'paid',
    },
    {
        text: 'Gelöscht',
        value: 'deleted',
    },
  ],

  // Every appointment group lifecycle state is available in this selector.
  // The requested-appointments endpoint folds all invoice workflow phases
  // (Apobilanz, temporary invoice, invoice and paid) into "completed", so they
  // deliberately do not appear as separate choices here.
  appointmentGroupStatusOptions: [
    {
        text: 'Entwurf',
        value: 'created',
    },
    {
        text: 'Angefragt',
        value: 'inquired',
    },
    {
        text: 'In Bearbeitung',
        value: 'open',
    },
    {
        text: 'Vergeben',
        value: 'allocated',
    },
    {
        text: 'Abgeleistet',
        value: 'completed',
    },
    {
        text: 'Storniert',
        value: 'canceled',
    },
    {
        text: 'Gelöscht',
        value: 'deleted',
    },
  ],
  hasRequestOptions : [
    {
      text: 'Von FB angefragt',
      value: 'true',
    },
    {
      text: 'Von FB Nicht angefragt',
      value: 'false',
    },
  ],
}


export const ticketFilters = {
  headers: [
    {
      text: '#',
      value: '_id'
    },
    {
      text: 'Status',
      value: 'wf_state'
    },
    {
      text: 'Referenz',
      value: 'ref_appointment_id'
    },
    {
      text: 'Titel',
      value: 'title'
    },
    {
      text: '',
      value: 'description'
    },
    {
      text: 'Typ',
      value: 'category'
    },
    {
      text: 'Datum',
      value: 'created'
    },
    {
      text: 'Ersteller',
      value: 'creator'
    },
    {
      text: 'Wiedervorlage',
      value: 'resubmit'
    },
    {
      text: 'Aktion',
      value: 'edit'
    }
  ],
  statusOptions: [{
    text: 'Alle',
    value: 'all'
  }, {
      text: 'Offen',
      value: 'open'
  }, {
      text: 'Geschlossen',
      value: 'closed'
  }]
}


// DISCOUNTS

export const discountTypeOptions = [
  { text: "Prozent", value: "percentage" },
  { text: "Nummer", value: "number" },
  { text: "Fixpreis", value: "fixprice" },
];

export const fixPriceFields = [
  { key: "fixPriceSubstitutionBaseRate", label: "Apotheker: Basis Preis" },
  { key: "fixPriceSubstitutionMargin", label: "Apotheker: Marge" },
  { key: "fixPricePtaBaseRate", label: "PTA: Basis Preis" },
  { key: "fixPricePtaMargin", label: "PTA: Marge" },
  { key: "fixPricePkaBaseRate", label: "PKA: Basis Preis" },
  { key: "fixPricePkaMargin", label: "PKA: Marge" },
];

export const flatRateFixPriceFields = [
  { key: "flatRateFixPriceSubstitutionBaseRate", label: "Apotheker: ND Basis Preis" },
  { key: "flatRateFixPriceSubstitutionMargin", label: "Apotheker: ND Marge" },
  { key: "flatRateFixPricePtaBaseRate", label: "PTA: ND Basis Preis" },
  { key: "flatRateFixPricePtaMargin", label: "PTA: ND Marge" },
  { key: "flatRateFixPricePkaBaseRate", label: "PKA: ND Basis Preis" },
  { key: "flatRateFixPricePkaMargin", label: "PKA: ND Marge" },
];

export const minimumPriceFields = [
  { key: "minimumPriceSubstitutionService", label: "Apotheker: Minimum Preis" },
  { key: "minimumPriceSubstitutionMargin", label: "Apotheker: Minimum Marge" },
  { key: "minimumPricePtaService", label: "PTA: Minimum Preis" },
  { key: "minimumPricePtaMargin", label: "PTA: Minimum Marge" },
  { key: "minimumPricePkaService", label: "PKA: Minimum Preis" },
  { key: "minimumPricePkaMargin", label: "PKA: Minimum Marge" },
];

export const AppointmentManagerDefaults = {
  serviceOptions: [
    { text: "Apotheker/in", value: "substitution" },
    { text: "PTA", value: "pta" },
    { text: "PKA", value: "pka" },
    { text: "QMS", value: "qms" },
    { text: "Storno", value: "storno" },
  ],
  billingOptions: [
    { text: "Stunden", value: "hours" },
    { text: "Pauschal", value: "flatrate" },
  ],
  appointmentApprovalOptions: [
    { text: "Automatisch freigegeben", value: "auto_approved", disabled: true },
    { text: "keine Angabe", value: "" },
    { text: "Termin freigegeben", value: "approved" },
    { text: "Es gibt Änderungen", value: "awaiting" },
  ],
  nightshift: {
    begin: "20:00",
    end: "07:00",
    time: "ND 20.00 - 07.00 Uhr",
    beginDateTime: "1900-01-01T20:00:00",
    endDateTime: "1900-01-02T07:00:00",
    billing: "flatrate",
    quantity: 0,
  },
}
